import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const dash = (v: unknown) => (v == null || v === "" ? "—" : String(v))

export const fullName = (p: any) =>
  [p?.nameFirst, p?.nameMiddle, p?.nameLast, p?.nameSuffix].filter(Boolean).join(" ")
